import keyCodes from '../../../../../../editJournal/constants/keyCodes';
import end from './end';
import isEndOfField from './isEndOfField';
import renderDict from './renderDict';
import isEndOfBlock from '../../../../../../editJournal/slateUtilities/plugins/Xscript/isEndOfBlock';
import mergeBullets from '../../../../../../editJournal/slateUtilities/plugins/mergeBullets';
import mergeULs from '../../../../../../editJournal/slateUtilities/plugins/mergeULs';
import removeSelectedNodes from './removeSelectedNodes';

export default (params) => {
  const { event, editor, updatePopUpKeys, showCommentCard, showContextCard } =
    params;

  if (event.which === keyCodes.DELETE) {
    const {
      value: { focusBlock, document },
    } = editor;
    const { key: focusBlockKey } = focusBlock;
    const parent = document.getParent(focusBlockKey);
    const { type: parentType, nodes: parentNodes } = parent;
    const parentNodesArray = parentNodes.toArray();
    const lastNode = parentNodesArray[parentNodes.size - 1];

    if (renderDict[parentType] === 'organization_role_editable_div') {
      if (lastNode.key !== focusBlockKey) {
        return false;
      }
    }

    if (renderDict[parentType] === 'list_item' && isEndOfBlock(editor)) {
      if (isEndOfField(editor)) return true;
      if (editor.value.nextBlock) mergeBullets(editor, event);

      mergeULs(editor);
      return true;
    }
    const isEnd = end(editor);
    if (isEnd) return true;

    /**
     * Deleting comments
     */
    const isPreventDefault = removeSelectedNodes({
      editor,
      props: { updatePopUpKeys, showCommentCard, showContextCard },
      eventCode: keyCodes.DELETE,
    });
    if (isPreventDefault) return true;
  }

  return false;
};
